'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var styles = {
  "listReset": "Polaris-Box--listReset",
  "Box": "Polaris-Box",
  "visuallyHidden": "Polaris-Box--visuallyHidden",
  "printHidden": "Polaris-Box--printHidden"
};

exports.default = styles;
